import { render, staticRenderFns } from "./image.vue?vue&type=template&id=da772de6&scoped=true"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"
import style0 from "./image.vue?vue&type=style&index=0&id=da772de6&prod&scoped=true&lang=css"
import style1 from "./image.vue?vue&type=style&index=1&id=da772de6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da772de6",
  null
  
)

export default component.exports